import { render } from "./Commandes.vue?vue&type=template&id=71f53d48&scoped=true"
import script from "./Commandes.vue?vue&type=script&lang=js"
export * from "./Commandes.vue?vue&type=script&lang=js"

import "./Commandes.vue?vue&type=style&index=0&id=71f53d48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f53d48"]])

export default __exports__